import { makeStyles } from '@material-ui/core/styles'


const useStyles = makeStyles((theme) => ({
  rule: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 20
  },
  regRule: {
    width: '100%',
    marginBottom: 12,
    '& .MuiFormLabel-root': {
      transform: 'translate(14px, -6px) scale(0.75)'
    }
  },
  ruleInput: {
    width: '100%',
    marginBottom: 12
  },
  checkbox: {
    color: theme.palette.text.secondary
  },
  remove: {
    marginLeft: 0,
    marginBottom: 12,
    paddingTop: 8,
    paddingBottom: 8,
    '& .MuiSvgIcon-root': {
      marginRight: 10
    },
    color: theme.palette.text.secondary,
    '&:hover': {
      color: theme.palette.text.primary
    }
  }
}))

export default useStyles
